// Import react lib
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

// Import services
import {
    fetchContactsInfos,
    fetchDeliveryInfos,
    fetchSchedulesInfos,
    updateContactsInfos,
    updateDeliveryInfos,
    updateSchedulesInfos,
} from '../services/about';

// ------------------------------------------------------------------------------
// FETCHER
// ------------------------------------------------------------------------------

// Hook to get contacts infos
export function useFetchContactsInfos() {
    return useQuery({
        queryKey: ['contacts'],
        queryFn: fetchContactsInfos,
    });
}

// Hook to get delivery infos
export function useFetchDeliveryInfos() {
    return useQuery({
        queryKey: ['delivery'],
        queryFn: fetchDeliveryInfos,
    });
}

// Hook to get schedules infos
export function useFetchSchedulesInfos() {
    return useQuery({
        queryKey: ['schedules'],
        queryFn: fetchSchedulesInfos,
    });
}

// ------------------------------------------------------------------------------
// UPDATERS
// ------------------------------------------------------------------------------

// Hook to update contact infos
export function useUpdateContacts() {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    // Create an update function
    async function updateContacts(instagram, whatsApp) {
        setIsLoading(true);
        setIsError(false);

        try {
            // try to update contacts
            await updateContactsInfos(instagram, whatsApp);
            return true;
        } catch (err) {
            setIsError(true);
            return false;
        } finally {
            setIsLoading(false);
        }
    }

    // Reset the error state
    function resetError() {
        setIsError(false);
    }

    return { updateContacts, isLoading, isError, resetError };
}

// Hook to update delivery infos
export function useUpdateDelivery() {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    // Create an update function
    async function updateDelivery(text) {
        setIsLoading(true);
        setIsError(false);

        try {
            // Try to update delivery
            await updateDeliveryInfos(text);
            return true;
        } catch (err) {
            setIsError(true);
            return false;
        } finally {
            setIsLoading(false);
        }
    }

    // Reset the error state
    function resetError() {
        setIsError(false);
    }

    return { updateDelivery, isLoading, isError, resetError };
}

// Hook to update schedules infos
export function useUpdateSchedules() {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    // Create an update function
    async function updateSchedules(text) {
        setIsLoading(true);
        setIsError(false);

        try {
            // Try to update schedules
            await updateSchedulesInfos(text);
            return true;
        } catch (err) {
            setIsError(true);
            return false;
        } finally {
            setIsLoading(false);
        }
    }

    // Reset the error state
    function resetError() {
        setIsError(false);
    }

    return { updateSchedules, isLoading, isError, resetError };
}
